<template>
  <div>
    <div id="iFrameContainer" class="pbiReportContainer" />
  </div>
</template>

<script>
/*global powerbi*/
import * as pbi from 'powerbi-client'; // eslint-disable-line no-unused-vars

export default {
  props: ['token', 'embedUrl'],
  data() {
    return {
      report: null
    };
  },
  mounted() {
    if (this.token && this.embedUrl) {
      this.LoadReport();
    }
  },
  watch: {
    token(newToken) {
      if (newToken) {
        this.LoadReport();
      }
    },
    embedUrl(newEmbedUrl) {
      if (newEmbedUrl) {
        this.LoadReport();
      }
    }
  },
  methods: {
    LoadReport() {
      const vm = this;
      const container = document.getElementById('iFrameContainer');
      let embedConfiguration = {
        type: 'report',
        embedUrl: vm.embedUrl,
        accessToken: vm.token
      };
      vm.report = powerbi.embed(container, embedConfiguration);
    }
  }
};
</script>
